import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import Loop from 'components/Loop';
import Paragraph from 'components/Paragraph';

import {
  MainWrapper,
  LoadingBarWrapper,
  LoadingMainBar,
  LoopWrapper,
} from 'apps/project/views/importLoading.styles';

const CurrentStepText = props => {
  const { status } = props;
  // for the user, there are three relevant statuses:
  // downloading, uploading and finishing
  const steps = [
    { count: 1, name: 'Downloading' },
    { count: 2, name: 'Uploading' },
    { count: 3, name: 'Finishing' },
  ];
  const currentIndex = status.includes('finished')
    ? 2
    : status.includes('exporting')
    ? 1
    : 0;

  return (
    <>
      <Paragraph>
        {currentIndex + 1} / {steps.length}
      </Paragraph>
      <Paragraph>{steps[currentIndex].name}</Paragraph>
    </>
  );
};

CurrentStepText.propTypes = {
  status: PropTypes.string,
};

const LoadingBar = props => {
  return (
    <LoadingBarWrapper>
      <LoadingMainBar percentage={`${props.percentage}%`} />
    </LoadingBarWrapper>
  );
};

LoadingBar.propTypes = {
  percentage: PropTypes.number,
};

const ImportLoading = observer(props => {
  const { status, generalProgress, stepProgress } = props;
  if (!status) return null;
  if (status.includes('error')) return null;

  const roundedGeneralProgress = Math.max(0.1, generalProgress);
  const roundedStepProgress = Math.max(0.1, stepProgress);
  const percentage = Math.round(
    roundedGeneralProgress * roundedStepProgress * 100,
  );

  return (
    <MainWrapper>
      <LoopWrapper>
        <Loop />
      </LoopWrapper>
      <LoadingBar percentage={percentage} />
      <CurrentStepText status={status} />
    </MainWrapper>
  );
});

ImportLoading.propTypes = {
  status: PropTypes.string,
  generalProgress: PropTypes.number,
  stepProgress: PropTypes.number,
};

export default ImportLoading;
